/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { SeizureSeriesMigrationJobDto } from '../model';
// @ts-ignore
import { SeizureSeriesMigrationRunRequest } from '../model';
// @ts-ignore
import { SeizureSeriesMigrationSeedRequest } from '../model';
// @ts-ignore
import { SeizureSeriesMigrationStatusDto } from '../model';
// @ts-ignore
import { SeizureSeriesMigrationStepResult } from '../model';
/**
 * AdminSeizureSeriesMigrationControllerApi - axios parameter creator
 * @export
 */
export const AdminSeizureSeriesMigrationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dates: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/technical/seizure-series-migration/dates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobs: async (limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/technical/seizure-series-migration/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetRunning: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/technical/seizure-series-migration/reset-running`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SeizureSeriesMigrationRunRequest} seizureSeriesMigrationRunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runNext: async (seizureSeriesMigrationRunRequest: SeizureSeriesMigrationRunRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seizureSeriesMigrationRunRequest' is not null or undefined
            assertParamExists('runNext', 'seizureSeriesMigrationRunRequest', seizureSeriesMigrationRunRequest)
            const localVarPath = `/api/admin/technical/seizure-series-migration/run-next`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(seizureSeriesMigrationRunRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SeizureSeriesMigrationSeedRequest} seizureSeriesMigrationSeedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seed: async (seizureSeriesMigrationSeedRequest: SeizureSeriesMigrationSeedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seizureSeriesMigrationSeedRequest' is not null or undefined
            assertParamExists('seed', 'seizureSeriesMigrationSeedRequest', seizureSeriesMigrationSeedRequest)
            const localVarPath = `/api/admin/technical/seizure-series-migration/seed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(seizureSeriesMigrationSeedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SeizureSeriesMigrationRunRequest} seizureSeriesMigrationRunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        start: async (seizureSeriesMigrationRunRequest: SeizureSeriesMigrationRunRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seizureSeriesMigrationRunRequest' is not null or undefined
            assertParamExists('start', 'seizureSeriesMigrationRunRequest', seizureSeriesMigrationRunRequest)
            const localVarPath = `/api/admin/technical/seizure-series-migration/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(seizureSeriesMigrationRunRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/technical/seizure-series-migration/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stop: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/technical/seizure-series-migration/stop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSeizureSeriesMigrationControllerApi - functional programming interface
 * @export
 */
export const AdminSeizureSeriesMigrationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSeizureSeriesMigrationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dates(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dates(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobs(limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<Array<SeizureSeriesMigrationJobDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobs(limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetRunning(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetRunning(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SeizureSeriesMigrationRunRequest} seizureSeriesMigrationRunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runNext(seizureSeriesMigrationRunRequest: SeizureSeriesMigrationRunRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<SeizureSeriesMigrationStepResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runNext(seizureSeriesMigrationRunRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SeizureSeriesMigrationSeedRequest} seizureSeriesMigrationSeedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seed(seizureSeriesMigrationSeedRequest: SeizureSeriesMigrationSeedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seed(seizureSeriesMigrationSeedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SeizureSeriesMigrationRunRequest} seizureSeriesMigrationRunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async start(seizureSeriesMigrationRunRequest: SeizureSeriesMigrationRunRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.start(seizureSeriesMigrationRunRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async status(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<SeizureSeriesMigrationStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.status(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stop(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stop(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminSeizureSeriesMigrationControllerApi - factory interface
 * @export
 */
export const AdminSeizureSeriesMigrationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSeizureSeriesMigrationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dates(options?: any): Promise<{ [key: string]: string; }> {
            return localVarFp.dates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobs(limit?: number, options?: any): Promise<Array<SeizureSeriesMigrationJobDto>> {
            return localVarFp.jobs(limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetRunning(options?: any): Promise<{ [key: string]: number; }> {
            return localVarFp.resetRunning(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SeizureSeriesMigrationRunRequest} seizureSeriesMigrationRunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runNext(seizureSeriesMigrationRunRequest: SeizureSeriesMigrationRunRequest, options?: any): Promise<SeizureSeriesMigrationStepResult> {
            return localVarFp.runNext(seizureSeriesMigrationRunRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SeizureSeriesMigrationSeedRequest} seizureSeriesMigrationSeedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seed(seizureSeriesMigrationSeedRequest: SeizureSeriesMigrationSeedRequest, options?: any): Promise<{ [key: string]: number; }> {
            return localVarFp.seed(seizureSeriesMigrationSeedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SeizureSeriesMigrationRunRequest} seizureSeriesMigrationRunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        start(seizureSeriesMigrationRunRequest: SeizureSeriesMigrationRunRequest, options?: any): Promise<{ [key: string]: boolean; }> {
            return localVarFp.start(seizureSeriesMigrationRunRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status(options?: any): Promise<SeizureSeriesMigrationStatusDto> {
            return localVarFp.status(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stop(options?: any): Promise<{ [key: string]: boolean; }> {
            return localVarFp.stop(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSeizureSeriesMigrationControllerApi - object-oriented interface
 * @export
 * @class AdminSeizureSeriesMigrationControllerApi
 * @extends {BaseAPI}
 */
export class AdminSeizureSeriesMigrationControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSeizureSeriesMigrationControllerApi
     */
    public dates(options?: AxiosRequestConfig) {
        return AdminSeizureSeriesMigrationControllerApiFp(this.configuration).dates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSeizureSeriesMigrationControllerApi
     */
    public jobs(limit?: number, options?: AxiosRequestConfig) {
        return AdminSeizureSeriesMigrationControllerApiFp(this.configuration).jobs(limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSeizureSeriesMigrationControllerApi
     */
    public resetRunning(options?: AxiosRequestConfig) {
        return AdminSeizureSeriesMigrationControllerApiFp(this.configuration).resetRunning(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SeizureSeriesMigrationRunRequest} seizureSeriesMigrationRunRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSeizureSeriesMigrationControllerApi
     */
    public runNext(seizureSeriesMigrationRunRequest: SeizureSeriesMigrationRunRequest, options?: AxiosRequestConfig) {
        return AdminSeizureSeriesMigrationControllerApiFp(this.configuration).runNext(seizureSeriesMigrationRunRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SeizureSeriesMigrationSeedRequest} seizureSeriesMigrationSeedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSeizureSeriesMigrationControllerApi
     */
    public seed(seizureSeriesMigrationSeedRequest: SeizureSeriesMigrationSeedRequest, options?: AxiosRequestConfig) {
        return AdminSeizureSeriesMigrationControllerApiFp(this.configuration).seed(seizureSeriesMigrationSeedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SeizureSeriesMigrationRunRequest} seizureSeriesMigrationRunRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSeizureSeriesMigrationControllerApi
     */
    public start(seizureSeriesMigrationRunRequest: SeizureSeriesMigrationRunRequest, options?: AxiosRequestConfig) {
        return AdminSeizureSeriesMigrationControllerApiFp(this.configuration).start(seizureSeriesMigrationRunRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSeizureSeriesMigrationControllerApi
     */
    public status(options?: AxiosRequestConfig) {
        return AdminSeizureSeriesMigrationControllerApiFp(this.configuration).status(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSeizureSeriesMigrationControllerApi
     */
    public stop(options?: AxiosRequestConfig) {
        return AdminSeizureSeriesMigrationControllerApiFp(this.configuration).stop(options).then((request) => request(this.axios, this.basePath));
    }
}
